import { WorkshopContext } from "./workshopContextValue";

// Quando este módulo for embutido no painel de gestão já existente, o
// painel "pai" deve envolver o <ChecklistApp> com este Provider, passando:
//
// - workshopId / workshopName: identificam a oficina logada.
// - config (opcional): permite o painel administrativo controlar
//   centralmente cor primária, logo, tema e funções habilitadas. Qualquer
//   campo presente aqui sobrepõe o que a oficina configurou localmente.
//   Exemplo: config={{ primaryColor: "#7f1d1d", features: { temaEscuro: false } }}
export function WorkshopProvider({ workshopId, workshopName, config = null, children }) {
  return (
    <WorkshopContext.Provider value={{ workshopId, workshopName, config }}>
      {children}
    </WorkshopContext.Provider>
  );
}
